import { Component } from 'react';

/**
 * ErrorBoundary catches rendering errors in the component tree and shows a
 * recovery UI instead of a completely blank/black screen.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Caught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#030712] flex items-center justify-center text-white">
          <div className="text-center max-w-md p-8">
            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-red-400 text-3xl">⚠</span>
            </div>
            <h2 className="text-2xl font-bold mb-3" style={{ fontFamily: 'Unbounded, sans-serif' }}>
              Something went wrong
            </h2>
            <p className="text-slate-400 mb-2 text-sm">
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
            <p className="text-slate-500 text-xs mb-8">
              Try refreshing the page. If the problem persists, clear your browser cache.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-2 bg-[#00E599] text-black rounded-sm font-semibold hover:bg-[#00CC88]"
              >
                Refresh Page
              </button>
              <button
                onClick={() => {
                  localStorage.removeItem('autoqa_session_token');
                  window.location.href = '/';
                }}
                className="px-6 py-2 bg-slate-800 text-slate-300 border border-white/10 rounded-sm hover:bg-slate-700"
              >
                Go to Home
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
